import { useState, useRef, useEffect } from 'react'

export const useExpandableText = (maxCollapsedHeight: number) => {
  const textRef = useRef<null | HTMLParagraphElement>(null)
  const [textHeight, setTextHeight] = useState<number | undefined>()

  const [isFullTextVisible, seIsFullTextVisible] = useState(false)

  useEffect(() => {
    setTextHeight(textRef.current?.clientHeight)
  }, [])

  const isTextExpandable = Boolean(textHeight && textHeight > maxCollapsedHeight)

  return {
    textRef,
    isTextExpandable,
    isFullTextVisible,
    onFullTextVisibleSet: () => seIsFullTextVisible(!isFullTextVisible),
  }
}
